import { formatKeywordForUrl } from '@/shared/utils/format';
import { ROUTES } from '@/types/common';
import DiseaseEncyclopediaModel from '../model/diseaseEncyclopedia';

export const createDiseaseEncyclopediaDetailUrl = (diseaseEncyclopedia?: DiseaseEncyclopediaModel): string => {
  if (!diseaseEncyclopedia) {
    return '';
  }
  const publicId = diseaseEncyclopedia.getPublicId();
  const keyword = diseaseEncyclopedia.getTitle();

  return createDiseaseEncyclopediaDetailUrlWithKeyword(publicId, keyword);
};

export const createDiseaseEncyclopediaDetailUrlWithKeyword = (publicId: string, keyword: string): string => {
  const formattedKeyword = formatKeywordForUrl(keyword);
  const encodedKeyword = encodeURIComponent(formattedKeyword);
  return `${ROUTES.DISEASE_ENCYCLOPEDIA.DETAIL.path}/${publicId}/${encodedKeyword}`;
};

const extractKeywordFromDiseaseEncyclopediaData = (diseaseEncyclopedia: any): string => {
  return diseaseEncyclopedia?.title ?? '';
};

export const createDiseaseEncyclopediaRedirectUrl = (publicId: string, diseaseEncyclopedia: any): string => {
  const keyword = extractKeywordFromDiseaseEncyclopediaData(diseaseEncyclopedia);
  return createDiseaseEncyclopediaDetailUrlWithKeyword(publicId, keyword);
};
